<cll-dialog-layout>
    <cll-dialog-header>
        <cll-dialog-title>Edit Zone</cll-dialog-title>
        <cll-dialog-subtitle>For {{ data.zone.name }}</cll-dialog-subtitle>
    </cll-dialog-header>
    <div class="dialog-detail">
        <cll-panel-tonal colour="info">
            <cll-icon cllPanelIcon>info</cll-icon>
            <div class="panel-text-group">
                <span class="panel-text-header">Important Information</span>
                <span class="panel-text-sub-header">Changing the name of zone will reassign the new name to any associated providers.</span>
            </div>
        </cll-panel-tonal>
        <cll-form-field label="Zone Name">
            <input cllFormInput [formControl]="zoneFormGroup.controls.name" type="text">
        </cll-form-field>
        <cll-form-field label="Zone Description">
            <input cllFormInput [formControl]="zoneFormGroup.controls.description" type="text">
        </cll-form-field>
    </div>
    <span class="dialog-divider"></span>
    <cll-dialog-footer>

        @if (editZoneRequest.error(); as error) {
            <app-error-panel [error]="error" />
        }

        <button cll-button
                colour="variant"
                cllDialogClose>
            Cancel
        </button>
        <button cll-filled-button
                colour="secondary"
                [disabled]="zoneFormGroup.invalid || this.editZoneRequest.loading()"
                (click)="edit()">
            Save
        </button>
    </cll-dialog-footer>
</cll-dialog-layout>
